import './assets/sass/app.scss';
import FrameImage from './components/frameImage';
import PropTypes from 'prop-types';
import React from 'react';
import HeaderComponent from './components/header';
import './appContainer.scss';

const AppLayout = ({ children }) => {
  return <div className='AppLayout nicheria'>
    {children}</div>;
};

AppLayout.props = {
  children: PropTypes.node.isRequired,
};

export default AppLayout;
